// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"464afaa2","455":"e2bcc59c","977":"fa948e7e"}[chunkId] + ".chunk.js";
};